$(() => {
    var form = $("#kayitBilgi");
    var raporNo = $("#raporNo");
    var file1 = $("#file1");
    var file2 = $("#file2");

    // jquery-validate select boş kontrolü için
    $.validator.addMethod(
        "notEqual",
        function (value, element, param) {
            return value !== param;
        },
        ""
    );
    // Sadece harf girilebilir
    jQuery.validator.addMethod(
        "lettersonly",
        function (value, element) {
            return (
                this.optional(element) ||
                /^[a-z áãâäàéêëèíîïìóõôöòúûüùĞğçñİıŞş]+$/i.test(value)
            );
        },
        "Sadece Harf Giriniz."
    );
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    var constantFunctions = {
        errorElement: "em",
        errorPlacement: function (i, e) {
            i.addClass("invalid-feedback"),
                "checkbox" === e.prop("type")
                    ? i.insertAfter(e.next("label"))
                    : i.insertAfter(e);
        },
        highlight: function (i, e, a) {
            $(i).addClass("is-invalid").removeClass("is-valid");
        },
        unhighlight: function (i, e, a) {
            $(i).addClass("is-valid").removeClass("is-invalid");
        },
        success: function (label, element) {
            $(element).removeClass("error");
        },
    };

    const formValidator = form.validate({
        rules: {
            telefon: {
                required: true,
            },
            eposta: {
                email: true,
            },
            sifre: {
                required: true,
                minlength: 8,
                maxlength: 32,
            },
            sifreTekrar: {
                required: false,
                equalTo: "#sifre",
            },
            raporNo: {
                required: false,
            },
            engelTur: {
                required: true,
                notEqual: "",
            },
            file1: {
                required: true,
            },
        },
        messages: {
            eposta: {
                email: "Lütfen geçerli bir E-Posta adresi giriniz.",
            },
            sifre: {
                required: "Lütfen bir değer giriniz.",
                maxlength: "Maksimum 32 karakter olabilir.",
                minlength: "Şifreniz en az 8 karakter olması gerek.",
            },
            sifreTekrar: {
                required: "Lütfen bir değer giriniz.",
                equalTo: "Şifreler Uyuşmuyor!",
            },
            raporNo: {
                required: "Lütfen bir değer giriniz.",
            },
            engelTur: {
                required: "Lütfen bir değer seçiniz.",
                notEqual: "Lütfen bir değer seçiniz.",
            },
            file1: "En az bir dosya seçmelisiniz.",
            file2: "En az bir dosya seçmelisiniz.",
        },
        ...constantFunctions,
        submitHandler: function (form) {
            // form.preventDefault();
            $("#questPhoneVerify").modal("show");
            return false;
        },
    });

    $("#kayitBilgiBtn").on("click", () => {
        // form.preventDefault();
        if ($("#kayitBilgi").valid()) {
            smsGonderRequest();
        }
    });

    $("#smsDogrulaBtn").on("click", () => {
        if ($("#smsDogrulaForm")[0].checkValidity()) {
            smsDogrulaRequest();
        }
    });

    // Dosya seçildiğinde doğrulama kuralını kontrol et
    $("#file1").on("change", function () {
        // form.validate().element(this);
        if ($("#file1")[0].files.length > 0) {
            form.find(".is-invalid").removeClass("is-invalid");
        }
    });

    checkRaporDurumRadio();
    $(".phonemask").mask("(000)000 00 00");

    $("input[name='raporDurum']").on("change", function () {
        checkRaporDurumRadio();
    });

    function checkRaporDurumRadio() {
        if ($("input[name='raporDurum']").val() !== undefined) {
            var isRaporDurum =
                $("input[name='raporDurum']:checked").val() === "1";
            if (isRaporDurum) {
                $("#fileWrap").hide(100);
                $("#raporNoWrap").show(50);
                raporNo.attr("name", "raporNo");
                file1.removeAttr("name");
                file2.removeAttr("name");
                formValidator.settings.rules.raporNo.required = true;
                formValidator.settings.rules.file1.required = false;
            } else {
                $("#fileWrap").show(50);
                $("#raporNoWrap").hide(100);
                raporNo.removeAttr("name");
                file1.attr("name", "file1");
                file2.attr("name", "file2");
                formValidator.settings.rules.raporNo.required = false;
                formValidator.settings.rules.file1.required = true;
            }
        }
    }

    function smsGonderRequest() {
        var data = $("#kayitBilgi").serialize();
        var url = $("#kayitBilgi").attr("sms");

        $.ajax({
            type: "POST",
            method: "POST",
            data: data,
            url: url,
            beforeSend: function () {},
            success: function (response) {
                if (response.durum == "success") {
                    $("#formHatalari").addClass("d-none");
                    $("#smsDogrulaForm #Kod").val("");
                    $("#questPhoneVerify").modal("show");
                } else {
                    $("#formHatalari").removeClass("d-none");
                    $("#formHataListesi").html("");
                    var metin = '<li class="mb-2">' + response.mesaj + "</li>";
                    $("#formHataListesi").append(metin);
                    $("#questPhoneVerify").modal("hide");
                }
            },
            error: function () {
                console.log("İstekte bir hata oluştu");
            },
        });
    }

    function smsDogrulaRequest() {
        var data = $("#smsDogrulaForm").serialize();
        var url = $("#smsDogrulaForm").attr("action");

        $.ajax({
            type: "POST",
            method: "POST",
            data: data,
            url: url,
            beforeSend: function () {},
            success: function (response) {
                if (response.durum == "success") {
                    $("#kodDogrulamaFormHatalari").addClass("d-none");
                    $("#questPhoneVerify").modal("hide");
                    kayitBilgiFormRequest();
                } else {
                    $("#kodDogrulamaFormHatalari").removeClass("d-none");
                    $("#kodDogrulaformHataListesi").html("");
                    var metin = '<li class="mb-2">' + response.mesaj + "</li>";
                    $("#kodDogrulaformHataListesi").append(metin);
                }
            },
            error: function () {
                console.log("İstekte bir hata oluştu");
            },
        });
    }

    function kayitBilgiFormRequest() {
        $("#questPhoneVerify").modal("show");
        // var data = $("#kayitBilgi").serialize();
        var formData = new FormData($("#kayitBilgi")[0]);
        var url = $("#kayitBilgi").attr("action");

        $.ajax({
            type: "POST",
            method: "POST",
            data: formData,
            url: url,
            contentType: false,
            enctype: "multipart/form-data",
            processData: false,
            beforeSend: function () {},
            success: function (response) {
                if (response.durum == "success") {
                    location.href = $("#kayitBilgi").attr("success");
                } else {
                    $("#formHatalari").removeClass("d-none");
                    $("#formHataListesi").html("");

                    if (response.veri !== undefined) {
                        response.veri.forEach((element) => {
                            var metin = '<li class="mb-2">' + element + "</li>";
                            $("#formHataListesi").append(metin);
                        });
                    } else {
                        var metin =
                            '<li class="mb-2">' + response.mesaj + "</li>";
                        $("#formHataListesi").append(metin);
                    }
                }
            },
            error: function () {
                console.log("İstekte bir hata oluştu");
            },
        });
    }
});
